import { getTemplateString } from 'common/helpers/string';
import { getTemplateToken } from 'common/helpers/tokensFormatter';
import PageLink from 'components/PageLink/PageLink';
import React from 'react';
interface Props {
  PageData?: any;
  Model?: any;
  layoutModel?: any;
}
const PaymentPlanLooseOfferConfirmation = ({
  PageData,
  Model,
  layoutModel,
}: Props) => {

  
  const currentBalanceToken = getTemplateToken(    
    Model?.PaymentPlanOfferConfirmationViewModel?.CurrentBalance
  );
  const confirmOfferPlanCancellationNotice = getTemplateString(
    Model?.PaymentPlanOfferConfirmationViewModel?.PageData.ConfirmOfferPlanCancellationDescription,
  );
  return (
    <>
      <div className="Grid Grid--white GridWhite--smFull">
    <div className="Grid-cell u-textCenter u-marginBxsm CreateRepaymentPlan-largePadding">
        <h3 className="Heading HeadingContentSplit-heading">{Model?.PaymentPlanOfferConfirmationViewModel?.PageData.Heading}</h3>
        <div className="Grid-cell u-marginBxsm">
            <img src="/assets/images/icons/exclamationmark.svg" />
        </div>

        <p className="Heading Heading-h3--portal u-marginBz">
            {Model?.PaymentPlanOfferConfirmationViewModel?.PageData.ConfirmOfferPlanCancellationHeading}
        </p>

        <p className="u-colorTextLightGray Text--medium u-marginBxsm">            
            <div          
          dangerouslySetInnerHTML={{
            __html: confirmOfferPlanCancellationNotice
              ? confirmOfferPlanCancellationNotice({
                'CurrentBalance': currentBalanceToken                  
                })
              : '',
          }}
        />
        </p>

        <p className="Heading Heading-h3--portal">
            {Model?.PaymentPlanOfferConfirmationViewModel?.PageData.ConfirmOfferPlanCancellationQuestion}
        </p>
        <div className="ButtonBar ButtonBar--spaceBetween ButtonBar-sm--spaceBetween ButtonBar--row-reverse">
          <PageLink url={Model?.PaymentPlanOfferConfirmationViewModel?.ConfirmPlanUpdateUrl} text={Model?.PaymentPlanOfferConfirmationViewModel?.PageData.OfferPlanCancellationConfirmBtnLabel} className="Button" />
          <PageLink url={Model?.PaymentPlanOfferConfirmationViewModel?.CancelPlanUpdateUrl} text={Model?.PaymentPlanOfferConfirmationViewModel?.PageData.ConfirmOfferPlanCancellationCancelBtnLabel} className="Button" />              
        </div>

    </div>
</div>
    </>
  );
};
export default PaymentPlanLooseOfferConfirmation;
